import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checked } = useAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-[#A1A4AB] text-sm animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return (
      <div className="max-w-md mx-auto my-20 card-surface p-8 text-center">
        <div className="font-serif text-2xl text-[#FDFBF7] mb-2">Admin access only</div>
        <div className="text-[#A1A4AB] text-sm">This area is reserved for station administrators.</div>
      </div>
    );
  }
  return children;
}
